// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"1275c4aa","263":"1275c4aa","839":"1275c4aa","993":"f6b14cb8"}[chunkId] + ".chunk.css";
};